import { FC } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import OverviewPage from '../overview/OverviewPage';

const DeceasedPage: FC<GeneralOverviewPageRenderedComponentProps> = (props) => (
  <OverviewPage {...props} deceased />
);

export default DeceasedPage;
